/**
 * Find all negative weight targets in taxonomy structure
 * Recursively searches for fields where weight is -1.0 and role is 'summation-source'
 * These fields are subtracted from totals (e.g., Dividends paid)
 * 
 * Matches application_filing.py lines 1547-1567
 */
export const findNegativeWeightTargets = (data: any, targets: string[] = []): string[] => {
  if (typeof data === 'object' && data !== null) {
    // Check if this node is a negative weight target
    if (data.target && data.weight === -1.0 && data.role === 'summation-source') {
      // Extract field name after colon (e.g., "ifrs-smes:Dividends" → "Dividends")
      const target = data.target.includes(':') ? 
        data.target.split(':')[1] : 
        data.target;
      
      if (!targets.includes(target)) {
        targets.push(target);
      }
    }
    
    // Recursively search in object values
    if (Array.isArray(data)) {
      data.forEach(item => findNegativeWeightTargets(item, targets));
    } else {
      Object.values(data).forEach(value => findNegativeWeightTargets(value, targets));
    }
  }
  
  return targets;
};

